import React, { ReactNode } from 'react'

import { Box, Stack, Typography } from '@mui/material'
import { ConnectedDotsIcon } from '../../Icons/ConnectedDotsIcon'
import { TransitionButton } from '../../Buttons/TransitionButton'
import { Variant } from '@mui/material/styles/createTypography'
import { useAuth } from '../../AuthContext/AuthProvider'
import { CreditCardErrorProps, CreditCardErrors } from './types'

export const CreditCardErrorComponent: React.FC<CreditCardErrorProps> = ({
  error
}) => {
  const { logout } = useAuth()

  const Wrapper: React.FC<{ children: ReactNode; variant?: Variant }> = ({
    children,
    variant
  }) => {
    return (
      <Typography variant={variant} component="div" align="center" gutterBottom>
        {children}
      </Typography>
    )
  }

  const Title: React.FC = () => {
    switch (error.type) {
      case CreditCardErrors.REJECTED:
        return (
          <Wrapper variant="h5">
            Your Card is not approved at this time.
          </Wrapper>
        )
      case CreditCardErrors.HTTP:
      case CreditCardErrors.GENERIC:
        return <Wrapper variant="h5">Oops!</Wrapper>
      default:
        return <Wrapper>{''}</Wrapper>
    }
  }

  const Body: React.FC = () => {
    switch (error.type) {
      case CreditCardErrors.REJECTED:
        return (
          <Wrapper variant="body1">
            We are unable to approve your card at this time. We understand that
            this may not be the decision you were expecting. You will receive a
            notification from us advising you of the reasons for decline. Please
            try again in 30 days.
          </Wrapper>
        )
      case CreditCardErrors.HTTP:
      case CreditCardErrors.GENERIC:
        return (
          <Wrapper variant="body1">
            We encountered an issue with processing your card. Please try again
            at a later time. If you continue to receive this error, reach out to{' '}
            <a href="mailto:support@paceline.fit">support@paceline.fit</a> for
            additional assistance.
          </Wrapper>
        )
      default:
        return <Wrapper>{''}</Wrapper>
    }
  }

  const handleDone = () => {
    switch (error.type) {
      case CreditCardErrors.GENERIC:
        logout()
        break
      default:
        logout()
    }
  }

  return (
    <Stack spacing={3} sx={{ maxWidth: 400 }}>
      <Title />

      <div style={{ textAlign: 'center' }}>
        <ConnectedDotsIcon sx={{ height: '1em', width: '2em' }} />
      </div>

      <Body />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}
      >
        <TransitionButton
          text="Done"
          onClick={handleDone}
          style={{ width: '8rem' }}
        />
      </Box>
    </Stack>
  )
}
